import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getCurrentUser, signOut } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import { User, LogOut } from 'lucide-react';
import TekyuLogo from '../TekyuLogo';
export default function TopNavBar() {
  const [user,setUser] = useState(null);
  const location=useLocation(); const navigate=useNavigate();
  useEffect(() => {
    let active=true;
    const refresh=async()=>{try {const current=await getCurrentUser(); if(active)setUser(current);}catch {if(active)setUser(null);}};
    refresh(); const stop=Hub.listen('auth',refresh);
    return ()=>{active=false;stop();};
  },[location.pathname]);
  const logOut=async()=>{await signOut();setUser(null);navigate('/dashboard');};
  return <nav aria-label="Main navigation" className="sticky top-0 z-50 flex flex-wrap items-center justify-between gap-3 border-b border-slate-800 bg-slate-900/95 px-5 py-4 text-sm text-slate-200">
    <Link to="/dashboard" className="flex items-center gap-2 font-bold text-green-400"><TekyuLogo className="h-8 w-auto" ariaLabel="Tekyu Logo" />Tekyu</Link>
    <div className="flex flex-wrap items-center gap-4">
      <Link to="/roles">Career paths</Link><Link to="/portal?tab=projects">Projects</Link><Link to="/portal?tab=roadmaps">Saved roadmaps</Link>
      {user ? <><Link to="/profile" className="inline-flex items-center gap-1"><User size={16}/>My account</Link><button onClick={logOut} className="inline-flex items-center gap-1"><LogOut size={16}/>Sign out</button></> : <Link to="/portal" className="rounded-lg bg-green-400 px-3 py-2 font-semibold text-slate-950">Sign in / join free</Link>}
    </div>
  </nav>;
}
